// src/data/skills.js
// level: 3 = proficient (used across multiple projects/coursework),
//        2 = comfortable (coursework + some applied use),
//        1 = familiar (exposure, still building depth)

export const skillCategories = [
  {
    icon: '💻',
    title: 'Languages',
    skills: [
      { name: 'JavaScript', level: 3 },
      { name: 'Python', level: 2 },
      { name: 'C++', level: 2 },
      { name: 'C', level: 2 },
    ],
  },
  {
    icon: '🌐',
    title: 'Frontend',
    skills: [
      { name: 'React', level: 3 },
      { name: 'React Router', level: 3 },
      { name: 'HTML5 & CSS3', level: 3 },
      { name: 'Responsive & Accessible UI', level: 2 },
    ],
  },
  {
    icon: '🔌',
    title: 'Backend & APIs',
    skills: [
      { name: 'Node.js', level: 2 },
      { name: 'REST APIs', level: 2 },
      { name: 'JWT Authentication', level: 2 },
      { name: 'Firebase (Auth & Firestore)', level: 2 },
    ],
  },
  {
    icon: '🗄️',
    title: 'Databases & Cloud',
    skills: [
      { name: 'SQL & NoSQL', level: 2 },
      { name: 'MongoDB', level: 2 },
      { name: 'AWS / Azure', level: 1 },
      { name: 'CI/CD (GitHub Actions)', level: 2 },
    ],
  },
  {
    icon: '🧩',
    title: 'Computer Science Fundamentals',
    skills: [
      { name: 'Data Structures & Algorithms', level: 2 },
      { name: 'Object-Oriented Design', level: 2 },
      { name: 'Software Analysis & Design', level: 2 },
    ],
  },
  {
    icon: '🛠️',
    title: 'Tools & Practices',
    skills: [
      { name: 'Git & Version Control', level: 3 },
      { name: 'Unix / Linux', level: 2 },
      { name: 'Software Testing', level: 2 },
      { name: 'Agile Project Management', level: 2 },
    ],
  },
];
